import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { easeOutQuint } from '@mnz-core/modules/page-scroll/page-scroll.logic';
import { PageScrollService } from '@mnz-core/modules/page-scroll/services/page-scroll.service';
import { NgxPageScrollCoreModule } from 'ngx-page-scroll-core';

@NgModule({
  imports: [
    CommonModule,
    NgxPageScrollCoreModule.forRoot({ duration: 3500, easingLogic: easeOutQuint })
  ],
  exports: [NgxPageScrollCoreModule],
  providers: [PageScrollService]
})
export class PageScrollModule {}
